var render = function render(){var _vm=this,_c=_vm._self._c;return _c('task-list',{attrs:{"columns":_vm.computedColumns,"personalTasks":_vm.personalTasks,"headerText":_vm.$t('task.header.titlePersonal'),"overview":_vm.overview || undefined},on:{"personalDateRange":_vm.fetchPersonalTasks}})
}
var staticRenderFns = []

export { render, staticRenderFns }